/* eslint-disable default-case */
// https://github.com/xigua1994/react-tiga-swiper/blob/master/README.zh-cn.md
import React from 'react'
import "./index.css";
import { BsyUtils } from "../../../utils/Utils";
import BsyDashBase from "../BsyDashBase";
import i18next from 'i18next';
import { dayjsUtils } from '../../../utils/dayjsUtils';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 * 
 */
class BsyDashRealTime extends BsyDashBase {
    constructor(props) {
        super(props);
        this.state = {
            realTimeModel: props.realTimeModel,
            text: '',
            fontSize:'7cqw',
            color:null,
            backgroundColor:null
        };
    }

    componentDidMount() {
        //不清楚为啥要加上才能显示带数据图标
        if (this.props.getContext) {
            this.props.getContext(this);
          }
        if(this.props.styles){
            if(this.props.styles.fontSetting){
                if(this.props.styles.fontSetting.length>0 || this.props.styles.fontSetting){
                    if(this.props.styles.fontSetting.titleColor){
                        this.setState({
                            color: this.props.styles.fontSetting.titleColor
                        })
                    }
                    
                }
            }
            if(this.props.styles.background){
                this.setState({
                    backgroundColor: this.props.styles.background
                })
            }
        }  
        this._week = () => {
            var d = new Date();
            var weekday = new Array(7)
            weekday[0] = i18next.t('day.week.Sunday')
            weekday[1] = i18next.t('day.week.Monday')
            weekday[2] =i18next.t('day.week.Tuesday')
            weekday[3] =i18next.t('day.week.Wednesday')
            weekday[4] = i18next.t('day.week.Thursday')
            weekday[5] =i18next.t('day.week.Friday')
            weekday[6] = i18next.t('day.week.Saturday')
            return weekday[d.getDay()]
        }
        this.getSetFont = (type)=>{
            var tt = '';
            switch (type) {
                case 'type-1':
                case 'type-3':
                    tt = '30cqb'
                    break;
                case 'type-2':
                case 'type-4':
                    tt = '22cqb'
                    break;
                case 'type-5':
                    tt = '20cqb'
                    break;
                case 'type-11':
                    tt = '80cqb'
                    break;
                case 'type-6':
                    tt = '16cqb'
                    break;
                case 'type-12':
                    tt = '38cqb'
                    break;
                case 'type-7':
                    tt = '71cqb'
                    break;
                case 'type-8':
                    tt = '40cqb'
                    break;
                case 'type-9':
                    tt = '44cqb'
                    break;
                case 'type-13':
                case 'type-14':
                    tt = '52cqb'
                    break;
                case 'type-10':
                    tt = '30cqb'
                    break;
            }
            this.setState({
                fontSize:tt
            })
        }
        this.getSetFont(this.state.realTimeModel)
        
        this._getTime = (type) => {
            var date = dayjsUtils.timeToTZ(new Date());
            //年
            var year = date.getFullYear();
            //月
            var month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
            //日
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            //时
            var hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
            //分
            var mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
            //秒
            var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            var tt = ''
            // eslint-disable-next-line default-case
            switch (type) {
                case 'type-1':
                    tt = year + "-" + month + "-" + day + ' ' + hh + ":" + mm + ":" + ss
                    break;
                case 'type-2':
                    tt = year + "-" + month + "-" + day + ' ' + hh + ":" + mm + ":" + ss + ' ' + this._week()
                    break;
                case 'type-3':
                    tt = year + "/" + month + "/" + day + ' ' + hh + ":" + mm + ":" + ss
                    break;
                case 'type-4':
                    tt = year + "/" + month + "/" + day + ' ' + hh + ":" + mm + ":" + ss + ' ' + this._week()
                    break;
                case 'type-5':
                    tt = year + i18next.t('yearTitle') + month + i18next.t('month') + day + i18next.t('day')+' '+ hh + i18next.t('hourTime') + mm + i18next.t('minute') + ss + i18next.t('second')
                    break;
                case 'type-6':i18next.t('yearTitle')
                    tt = year +  i18next.t('yearTitle') + month + i18next.t('month') + day + i18next.t('day')+' ' + hh + i18next.t('hourTime') + mm + i18next.t('minute') + ss + i18next.t('second')+' ' + this._week()
                    break;
                case 'type-7':
                    tt = hh + ":" + mm + ":" + ss
                    break;
                case 'type-8':
                    tt = hh + ":" + mm + ":" + ss + ' ' + this._week()
                    break;
                case 'type-9':
                    tt = hh + i18next.t('hourTime') + mm + i18next.t('minute') + ss + i18next.t('second')
                    break;
                case 'type-10':
                    tt = hh + i18next.t('hourTime') + mm + i18next.t('minute') + ss + i18next.t('second')+' '  + this._week()
                    break;
                case 'type-11':
                    tt = this._week()
                    break;
                case 'type-12':
                    tt = year + i18next.t('yearTitle') + month + i18next.t('month') + day + i18next.t('day')                
                    break;
                    case 'type-13':
                        tt = year + "-" + month + "-" + day
                        break;
                    case 'type-14':
                        tt = year + "/" + month + "/" + day             
                        break;    
            }
            return tt
        }
        const dd = this._getTime(this.state.realTimeModel)
        this.setState({
            text: dd
        })
        setInterval(()=> {
            const cc = this._getTime(this.state.realTimeModel)
            this.setState({
                text: cc
            })
        }, 1000)
    }
    loadData = (n, d) => {
        BsyUtils.applyFunc(this, this.props.onLoadSuccess, [{}, n, d], !1);
      };
    render() {
        return <>
            <div className='t-real-time-show' style={{'background':this.state.backgroundColor}}>
                <div className='t-block-title' style={{"fontSize":this.state.fontSize,'color':this.state.color}}>{this.state.text}</div>
            </div>
        </>;
    }
}

BsyDashRealTime.propTypes = propTypes;
BsyDashRealTime.defaultProps = defaultProps;
// #endregion

export default BsyDashRealTime;